import { createParser, system } from "@styled-system/core";
import { t } from "../utils";
var config = {
  alignItems: true,
  alignContent: true,
  justifyItems: true,
  justifyContent: true,
  flexWrap: true,
  flexDirection: true,
  flex: true,
  flexGrow: true,
  flexShrink: true,
  flexBasis: t.sizes("flexBasis"),
  justifySelf: true,
  alignSelf: true,
  order: true,
  flexDir: t.prop("flexDirection")
};
/**
 * Types for flexbox related CSS properties
 */

export var flexbox = system(config);
export var flexboxParser = createParser(config);